import { Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';

import { type TourAction, TourActionButton } from './PdpTourActionButton';

export const PdpAgentTourCard = ({ action }: { action: TourAction }) => (
  <Col
    as="section"
    aria-label="Schedule a tour with an agent"
    className="w-full gap-5 rounded-[18px] bg-od-bg-tertiary px-6 py-5"
  >
    <Col className="gap-2">
      <Text as="h2" className="text-subheader-xs text-od-content-primary">
        Schedule a tour with an agent
      </Text>
      <Text className="min-h-5 text-label-sm text-od-content-secondary">
        Share with your agent to book a tour
      </Text>
    </Col>
    <TourActionButton
      action={action}
      label="Share this link with your agent"
      variant="secondary"
      className="h-12 px-3 text-label-sm"
    />
  </Col>
);
